/**
 * Format a duration in seconds to HH:MM:SS string.
 */
export function formatDuration(totalSeconds: number): string {
  const safe = Math.max(0, totalSeconds);
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = Math.floor(safe % 60);

  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

/**
 * Format a duration in seconds to a human-readable short form (e.g., "2h 30m").
 */
export function formatDurationShort(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  if (hours === 0) {
    return `${minutes}m`;
  }

  return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
}

/**
 * Display-only: adds thousands commas to the hours part of an "HH:MM:SS" string.
 * e.g. "47081:41:37" → "47,081:41:37". Safe to use only in JSX — never in exports.
 */
export function displayDuration(hms: string): string {
  return hms.replace(/^(\d+)(:)/, (_, h, colon) => `${parseInt(h, 10).toLocaleString('en-US')}${colon}`);
}

/**
 * Display-only: adds thousands commas to the hours part of an "Xh Ym" string.
 * e.g. "47081h 41m" → "47,081h 41m". Safe to use only in JSX — never in exports.
 */
export function displayDurationShort(hm: string): string {
  return hm.replace(/^(\d+)(h)/, (_, h, suffix) => `${parseInt(h, 10).toLocaleString('en-US')}${suffix}`);
}
